<template>
    <div class="challenge-flow-item">
        <span class="challenge-flow-item__number">{{ number }}</span>
        <span class="challenge-flow-item__text">{{ text }}</span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            number: { type: Number, default: 7},
            text: { type: String, default: 'Lorem ipsum dolor sit amet'}
        }
    };
</script>

<style scoped src="@/css/components/challenge-flow-item.css"></style>